export default __webpack_public_path__ + "static/media/psych_instruction.9fb01696.pdf";